import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';

 import config from  '../../../config';

import {getFieldByPathFormatter, customTableSelect,customFormatter,priceFormatter} from 'util/Utils';
class AdminPalletProductToImportListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {

        };
        this.tableRef = null
    }



    render() {
        const  selectRowProp = {
            mode: 'checkbox',
            columnWidth: '10px',
            onSelect: this.props.onRowSelect,
            onSelectAll: this.props.onAllRowSelect,
            customComponent: this.props.customMultiSelect

        }

        return (
            <div className="panel panel-default">
                <div className=" databases-table">
                    <BootstrapTable ref={(ref) => {
                        if (!this.tableRef && ref) {
                            this.tableRef = ref;

                        }
                    }}
                                    data={this.props.data}
                                    selectRow={ selectRowProp }
                                    remote={true}
                                    hover={true}
                                    condensed={true}
                                    striped={true}
                                    options={ {
                                        ...config.bootstrapTableOptions,
                                        onSortChange: this.props.onSortChange
                                    } } >
                        <TableHeaderColumn width="60px"  dataAlign="center" dataField="ProductName"    >Product Name</TableHeaderColumn>
                        <TableHeaderColumn width="20px"   dataAlign="center"    dataField="PalletProductData.Quantity"
                                           formatExtraData={ {path:['PalletProductData',  'Quantity']}}
                                           dataFormat={ getFieldByPathFormatter }
                        >Quantity</TableHeaderColumn>

                        <TableHeaderColumn width="0px"  dataField="_id" isKey={true} hidden={true}
                                           autoValue={ true } hiddenOnInsert>Id</TableHeaderColumn>
                        <TableHeaderColumn width="30px"  dataAlign="center"
                                           dataField="PalletProductData.RetailToUnit"      dataFormat={ priceFormatter.bind(this) }     formatExtraData={ {path:['PalletProductData',  'RetailToUnit']}}
 dataSort={true}  >Retail/unit</TableHeaderColumn>
                        <TableHeaderColumn width="30px"  dataAlign="center"
                                           dataField="PalletProductData.WhatWePaidToUnit"    dataFormat={ priceFormatter.bind(this) }  formatExtraData={ {path:['PalletProductData',  'WhatWePaidToUnit']}}
                                  dataSort={true} >What we paid/unit</TableHeaderColumn>
                        <TableHeaderColumn width="30px"  dataAlign="center"
                                           dataField="PalletProductData.TotalCOGS"    dataFormat={ priceFormatter.bind(this) }  formatExtraData={ {path:['PalletProductData',  'TotalCOGS']}}
                                           dataSort={true} >COGS for 1 product</TableHeaderColumn>
                        <TableHeaderColumn width="30px"  dataAlign="center"
                                           dataField="PalletProductData.PaymentDate"
                                           formatExtraData={ {path:['PalletProductData',  'PaymentDate']}}
                                           dataFormat={ getFieldByPathFormatter }
                                           dataSort={true} >Payment date</TableHeaderColumn>
                        <TableHeaderColumn width="30px"  dataAlign="center"
                                           dataField="PalletProductData.PaymentDate"
                                           formatExtraData={ {path:['PalletProductData',  'ProductPalletNumber']}}
                                           dataFormat={ getFieldByPathFormatter }
                                           dataSort={true} >Pallet Number</TableHeaderColumn>
                        <TableHeaderColumn width="30px"  dataAlign="center"
                                           dataField="PalletProductData.PalletProductNotes"         formatExtraData={ {path:['PalletProductData',  'PalletProductNotes']}}
                                           dataFormat={ getFieldByPathFormatter }
                                           dataSort={true} >Payment notes</TableHeaderColumn>

                    </BootstrapTable>
                </div>
            </div>

        );
    }
}


export default AdminPalletProductToImportListTable;
